import React from 'react';
import {
  Accordion,
  Alert,
  Button,
  Col,
  Form,
  Row,
  Spinner,
} from 'react-bootstrap';
import { PodInfo } from './types';
import PodMonitoringCard from './PodMonitoringCard';
import { SourceLegend, SourcePills } from './Shared';

export default function PodMonitoringTab({
  pods,
  filteredPods,
  podSearch,
  setPodSearch,
  sources,
  selectedSource,
  onSourceChange,
  isLoading,
  error,
  isFetching,
  refetch,
}: {
  pods: Array<[string, PodInfo]>;
  filteredPods: Array<[string, PodInfo]>;
  podSearch: string;
  setPodSearch: (value: string) => void;
  sources: string[];
  selectedSource: string;
  onSourceChange: (value: string) => void;
  isLoading: boolean;
  error: any;
  isFetching: boolean;
  refetch: () => void;
}) {
  const podSourcesParam =
    selectedSource && selectedSource !== 'all' ? selectedSource : '';

  return (
    <>
      <div className="adsure-card mb-3">
        <div className="adsure-card-body">
          <Row className="align-items-end g-3">
            <Col lg={3}>
              <div className="adsure-section-label">Sources</div>
              <SourcePills
                sources={sources}
                selectedSource={selectedSource}
                onChange={onSourceChange}
              />
            </Col>
            <Col lg={5}>
              <div className="adsure-section-label">Search by pod name</div>
              <Form.Control
                type="text"
                placeholder="Type a pod name"
                value={podSearch}
                onChange={event => setPodSearch(event.target.value)}
              />
            </Col>
            <Col lg={2}>
              <div className="adsure-section-label">Pods</div>
              <div className="text-muted small">
                Showing {filteredPods.length} of {pods.length}
              </div>
            </Col>
            <Col lg={2} className="text-lg-end">
              <Button
                size="sm"
                variant="outline-primary"
                onClick={() => refetch()}
                disabled={isFetching}
              >
                {isFetching ? 'Refreshing...' : 'Refresh Pods'}
              </Button>
            </Col>
          </Row>
        </div>
      </div>

      <SourceLegend />

      {isLoading ? (
        <div className="adsure-loading-state">
          <Spinner animation="border" className="me-2" />
          Loading AdSure monitoring pods...
        </div>
      ) : error ? (
        <Alert variant="danger">Failed to load AdSure monitoring pods.</Alert>
      ) : pods.length === 0 ? (
        <Alert variant="light">No pods were returned by the monitoring API.</Alert>
      ) : filteredPods.length === 0 ? (
        <Alert variant="light">
          No pods matched <strong>{podSearch}</strong>.
        </Alert>
      ) : (
        <Accordion alwaysOpen className="adsure-pod-accordion">
          {filteredPods.map(([podName, podInfo]) => (
            <PodMonitoringCard
              key={podName}
              podName={podName}
              podInfo={podInfo}
              podSourcesParam={podSourcesParam}
            />
          ))}
        </Accordion>
      )}
    </>
  );
}
